import React from "react";
import { useSelector } from "react-redux";
import { Router as BrowserRouter } from "react-router-dom";

import { PagesSwitch } from "src/navigation/Switch";
import { history } from "src/navigation/store";
import { useHistory } from "src/navigation/useHistory";
import { RootState } from "src/store";

export const Router: React.FC = () => {
  const { location, action } = useHistory();
  const isAuthenticated = useSelector(
    (state: RootState) => state.auth.isAuthenticated
  );
  const mode = isAuthenticated ? "authenticated" : "guest";

  return (
    <BrowserRouter
      location={location}
      navigationType={action}
      navigator={history}
    >
      <PagesSwitch mode={mode} />
    </BrowserRouter>
  );
};
